import { type HttpRequestFn, useHttp, type UseHttpOptions } from '@tundr/http';
import type {
  City,
  GeocodeAddressPayload,
  GeocodeAddressResult,
  GetCitiesPayload,
  GetProvincesPayload,
  Province,
} from './geo.types.ts';

const API_BASE_PATH = 'geo';

const getCities: HttpRequestFn<City[], GetCitiesPayload> = (http) => (args) => {
  return http.get(`${API_BASE_PATH}/cities`, { params: args });
};

export const useGetCities = (
  params: UseHttpOptions<City[], GetCitiesPayload> = {},
) => useHttp(getCities, params);

const getProvinces: HttpRequestFn<Province[], GetProvincesPayload> =
  (http) => (args) => {
    return http.get(`${API_BASE_PATH}/provinces`, { params: args });
  };

export const useGetProvinces = (
  params: UseHttpOptions<Province[], GetProvincesPayload> = {},
) => useHttp(getProvinces, params);

const geocodeAddress: HttpRequestFn<
  GeocodeAddressResult,
  GeocodeAddressPayload
> = (http) => (args) => {
  return http.get(`${API_BASE_PATH}/geocode`, { params: args });
};

export const useGeocodeAddress = (
  params: UseHttpOptions<GeocodeAddressResult, GeocodeAddressPayload> = {},
) => useHttp(geocodeAddress, { manual: true, ...params });
